var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"root",attrs:{"viewBox":"0 0 10 10"}},[_c('line',{attrs:{"x1":"0","x2":"10","y1":"5","y2":"5"}}),_c('line',{ref:"yLine",attrs:{"x1":"5","x2":"5","y1":"0","y2":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }